import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import SubSpecialitiesInfo from "../../data/SubSpecialitiesInfo";
import proceduresData from "../../data/proceduresData";
import GetINTouch from "../Contactus/GetINTouch";
import ServicesList from "./ServicesList";

export default function ImagingService() {
  const { hash } = useLocation();

  useEffect(() => {
    // Function to attempt scrolling to the target element
    const scrollToHash = () => {
      if (hash) {
        const targetId = hash.replace("#", "");
        const element = document.getElementById(targetId);
        if (element) {
          // Calculate navbar height (adjust based on your navbar's actual height)
          const navbarHeight = 180; // Adjust this value as needed
          const elementPosition =
            element.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({
            top: elementPosition - navbarHeight,
            behavior: "smooth",
          });
        } else {
          console.warn(`Element with ID ${targetId} not found`);
          // Scroll to top if hash is invalid
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      } else {
        // Scroll to top if no hash
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    };

    // Initial attempt
    scrollToHash();

    // Retry after a short delay to account for AOS or DOM rendering
    const timer = setTimeout(scrollToHash, 500);

    // Cleanup timer on unmount
    return () => clearTimeout(timer);
  }, [hash]);

  // Combine proceduresData and SubSpecialitiesInfo with pathSegment
  const combinedServices = [
    ...proceduresData.map((item) => ({
      ...item,
      pathSegment: "tests", // Add pathSegment for procedures
    })),
    ...SubSpecialitiesInfo.map((item) => ({
      ...item,
      pathSegment: "subspecialities", // Add pathSegment for subspecialties
    })),
  ];

  // Debugging: Log combinedServices to verify data
  // console.log("Combined Services:", combinedServices);

  return (
    <div>
      <title>
        Diagnostic Imaging Center | Imaging and Diagnostics Services
      </title>
      <meta
        name="description"
        content="Diagnostic imaging center providing advanced imaging and diagnostics with breast imaging services for accurate results and early detection of health issues."
      />
      <div className="pt-16 sm:pt-20 md:pt-24 lg:pt-[12.0625rem] overflow-hidden">
        <div className="px-4 py-8 sm:px-6 sm:py-10 md:px-8 md:py-12 lg:px-10 lg:py-16">
          {/* Main Heading */}
          <div className="relative mb-10 lg:mb-60">
            <div className="flex justify-center pt-28 md:pt-12 lg:pt-0">
              <div>
                <h1 className="font-robout font-black text-white text-[3rem] leading-[60px] md:text-[6rem] lg:text-[7.5rem] lg:leading-[120px] xl:text-[10.25rem] md:leading-snug xl:leading-[140px] 2xl:leading-[144px] tracking-[-.03em] capitalize">
                  {/* <span>Imaging</span> <br />
                  <span className="xl:ml-[25.5rem] lg:ml-[18rem] md:ml-[10rem] ml-[3rem]">
                    Services
                  </span> */}
                  Services
                </h1>
              </div>
            </div>
          </div>
          <ServicesList />
          {/* Split Layout in groups of two */}
          {Array.from(
            { length: Math.ceil(combinedServices.length / 2) },
            (_, groupIndex) => (
              <div
                key={groupIndex}
                className={`grid grid-cols-1 lg:grid-cols-2 gap-16 xl:w-4/5 w-11/12 mx-auto ${
                  groupIndex > 0 ? "xl:mt-40 lg:mt-28 mt-20" : ""
                }`}
              >
                {combinedServices
                  .slice(groupIndex * 2, groupIndex * 2 + 2)
                  .map((service, idx) => (
                    <Link
                      key={idx}
                      to={`/services/${service.pathSegment}/${
                        service.slug ||
                        service.title.toLowerCase().replace(/\s+/g, "-")
                      }`}
                      aria-label={`/services/${service.pathSegment}/${
                        service.slug ||
                        service.title.toLowerCase().replace(/\s+/g, "-")
                      }`}
                      className="relative"
                      data-aos="fade-up"
                      data-aos-delay={`${(idx + 1) * 50}`}
                      onClick={() =>
                        console.log(
                          `Navigating to: /services/${service.pathSegment}/${
                            service.slug ||
                            service.title.toLowerCase().replace(/\s+/g, "-")
                          }`
                        )
                      }
                    >
                      <div
                        className={`relative xl:h-[500px] lg:h-[400px] overflow-hidden rounded-[2rem] ${
                          service.extraTopMargin ? "mt-10" : ""
                        }`}
                      >
                        <img
                          src={service.image || "/path/to/default-image.png"} // Fallback image
                          alt={service.alt || service.title}
                          className="w-full h-full object-cover transition-transform duration-1000 ease-in-out hover:scale-110 cursor-pointer"
                        />
                      </div>
                      <div>
                        <p className="text-white text-[1.55rem] leading-[1.14286] md:tracking-[-.06em] mt-4 md:w-[21.875rem] font-robout">
                          {service.subTitle || service.subdescription}
                        </p>
                        <h3 className="text-white text-[28px] md:text-[2.75rem] md:leading-[1.125] md:tracking-[-.06em] font-black capitalize font-robout mt-4">
                          {service.title}
                        </h3>
                      </div>
                    </Link>
                  ))}
              </div>
            )
          )}
        </div>
      </div>
      <GetINTouch />
    </div>
  );
}
